import firebase from 'firebase';
import GeoFire from 'geofire';

const UID_DELIMITER = "%%%";

/* Get all Items from the Firebase Database */
function getAllItems (
    frdRef,
    onGetItemsFinished ) {

    /* Fetch all the lfItems from Firebase Database */
    frdRef.child('lfitems').on('value', function(dataSnapshot) {
        var lfItems = [];   
        dataSnapshot.forEach(function(childSnapshot) { 
            var lfItem = childSnapshot.val();
            lfItem['.key'] = childSnapshot.key;
            lfItems.push(lfItem);
        });
        onGetItemsFinished( lfItems );
    } ); 


} // firebaseGetAllItems 



/* Perform and advanced search, using Geofire and Firebase Database*/
function advancedSearch (geofireRef, 
    frdRef,
    lat, 
    lng, 
    searchRadiusMiles, 
    lfType, 
    status,
    onSearchFinished ) {

    // Counter to track how many items are within the query radius
    var geoFireItemCount = 0;
    var firebaseItemCount = 0;
    var geoFireItemTotalCount = -1;
    var searchCallbackWasCalled = false;
    // Store the found items.
    var lfItems = [];  

    // console.log( 'advancedSearch : lat = ' + lat + ", lng = " + lng + ", searchRadiusMiles = " + searchRadiusMiles + ", lfType = " + lfType + ", status = " + status );
    var geoFire = new GeoFire(geofireRef);
    
    var geoQuery = geoFire.query({
        center: [lat, lng],
        radius: searchRadiusMiles
      });

    // Attach event callbacks to the query
    geoQuery.on("key_entered", function(key, location) {
        // console.log("onKeyEnteredRegistration geofire key = " + key  );
        const frdUID = isInFilter( key, lfType, status, false, 0 );
        if( frdUID != null ) {
            // console.log("isInFilter = true. frdUID = " + frdUID );
            geoFireItemCount++;

            /* Geofire found an item.  
                Use frdUID to query the firebase database to get the rest of the item's data.
            */
            frdRef.child('lfitems').child(frdUID).on('value', function(snapshot) {
                // console.log( "fetched item from firebase.  frdUID = " +  frdUID ); 
                
                var lfItem = snapshot.val();
                if( lfItem != null ){
                    lfItem['.key'] = snapshot.key;
                    lfItems.push(lfItem); 
                }
                else{
                    // console.log( "After fetch.  lfItem is null.  frdUID = " +  frdUID ); 
  
                }
 
            });

            firebaseItemCount++;

            
            /*
                This may be occur before geofire ready has fired.
                So do a check here, and also do the same check in the geofire ready callback.
            */
            // console.log( "geoFireItemTotalCount = " + geoFireItemTotalCount + 
            //", firebaseItemCount = " + firebaseItemCount );
            if( ( firebaseItemCount === geoFireItemTotalCount ) && searchCallbackWasCalled === false ) {
                // finished.  Notify caller.   
                //console.log( "Calling onSearchFinished callback. lfItems length = " + lfItems.length );                 
                onSearchFinished( lfItems );
                searchCallbackWasCalled = true;
            }
            
        }
        else{
            //console.log("isInFilter = false" );
        }
        
    });

    geoQuery.on("key_exited", function(key, location) {
        // console.log("onKeyExitedRegistration" + key  );
    });

    geoQuery.on("key_moved", function(key, location) {
        // console.log("onKeyExitedRegistration" + key  );
    });

    geoQuery.on("ready", function() {
        // console.log("GeoQuery has loaded and fired all other events for initial data");
        geoFireItemTotalCount = geoFireItemCount;
        // console.log( "Found " + geoFireItemTotalCount + " items.");
        // Geofire has finished it's query.
        if( geoFireItemCount === 0 ){
            // No items were found.
            // Let the caller know.
            onSearchFinished( null );
        }
        else {
            if( ( firebaseItemCount === geoFireItemTotalCount ) && searchCallbackWasCalled === false ) {
                // finished.  Notify caller.   
                // console.log( "Calling onSearchFinished callback. lfItems length = " + lfItems.length );                 
                onSearchFinished( lfItems );
                searchCallbackWasCalled = true;
            }
        }
    });


    /*  Parses the GeoFire UID.  
         Returns Firebase Realtime Database UID if the given GeoFireUID 
         matches the requested filters.
         Returns null if no match
     */
    function isInFilter ( geoFireUid, 
        requestedLfType, 
        requestedStatus, 
        bRequestedHasReward, 
        requestedCreationTime ) {

        // parse the geoFireUid to get fireBaseDataStorageUid, type, status, reward, creationtime
        // Format : <firebase_data_storage_uid>***<type>***<status>***<reward>***<creation_time>\\

        let strings = geoFireUid.split( UID_DELIMITER );
        if (strings.length !== 5)
            return null;

        const frdUID = strings[0];
        const sLfType = strings[1];
        const sStatus = strings[2];
  
        if (frdUID == null)
            return null;

        
        const lfType = parseInt( sLfType, 10 );
        const status = parseInt( sStatus, 10 );
   
        if (lfType !== requestedLfType)
            return null;

        if (status !== requestedStatus)
            return null;

        return frdUID;
    }



} // function advancedSearch


function buildGeofireUid ( databaseUid, lfType, status, creationTime ) {
    return databaseUid +  UID_DELIMITER + 
      lfType + UID_DELIMITER + 
      status + UID_DELIMITER +
      "0" + UID_DELIMITER +
      creationTime;
}

 function addItemToGeofire ( geofireRef, key, data ) {
    /* Add an entry to geofire */
    let geofireKey = buildGeofireUid( key, data.lfType, data.status, data.creationTime );
    // console.log( "geofireKey = " + geofireKey );
    // console.log( "lat = " + data.lat + ", lng  = " + data.lng );

    var geoFire = new GeoFire(geofireRef);
  
    geoFire.set(geofireKey, [data.lat, data.lng]).then(function() {
      // console.log("Provided key has been added to GeoFire");
    }, function(error) {
      // console.log("Geofire Error: " + error);
    });
  }

  function uploadFile( fbStorageRef, filename, file ) {

    // console.log( "uploading file");
    var uploadTask = fbStorageRef.child(
      'images/' + filename).put(file);
    
    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            //var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            // console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
                default:
                    // console.log('Upload');
                break;
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    // console.log('Upload is paused');
                break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    // console.log('Upload is running');
                break;
            }
        }, function(error) {
    
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
            default:
                // console.log('Upload error' + error.code);
            break;
            case 'storage/unauthorized':
                // User doesn't have permission to access the object
            break;
        
            case 'storage/canceled':
            // User canceled the upload
            break;          
            case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
            break;
        }
      }, function() {
        // Upload completed successfully, now we can get the download URL
        // var downloadURL = uploadTask.snapshot.downloadURL;
        });  
    }
    
      
  

export default { getAllItems, advancedSearch, addItemToGeofire, uploadFile }




// WEBPACK FOOTER //
// ./src/Services/firebaseManager.js